var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup519(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.697,
    height: 11.82,
    viewBox: "0 0 6.697 11.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519",
    transform: "translate(-250.464 807.471) rotate(-90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 5.061,
    y2: 5,
    transform: "translate(796.5 251.312)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x1: 5.061,
    y2: 5,
    transform: "translate(801.561 251.312)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup519);
export default __webpack_public_path__ + "static/media/Group 519.a9fc22e78c064b0c880595ba01a1a885.svg";
export { ForwardRef as ReactComponent };